/* eslint-disable no-shadow */
/* eslint-disable import/no-unresolved */
import DetailsHeading from "src/shared/DetailsHeading";
import Button from "@mui/material/Button";
import CustomModal from "src/shared/CustomModal";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import regex from "src/helpers/regex";
import { useSelector, useDispatch } from "react-redux";
import {
  SET_TOAST_ERROR,
  setAssignmentFlagStatus,
  setGeneralDetails,
  setPostMEFLoading,
  setStepDetails
} from "src/redux/Actions/common";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { useMutation } from "react-query";
import store from "src/redux/store";
import { loanDetailsUpdate } from "src/services/FormDetails";
import { useNavigate } from "react-router";
import ConfirmationModal from "src/shared/ConfirmationModal";
import { deleteAssignmentDetails } from "src/services/Master";
import { setAssignmentId } from "src/redux/Thunk";
import BankDetails from "./BankDetails";
import BasicInfo from "./BasicInfo";

function GeneralDetails() {
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const genericDetails = mefSchema?.genericDetails || {};
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [assignmentModalOpen, setAssignmentModalOpen] = useState(false);
  const generalDetailsData = useSelector((state: any) => state.generalDetails);
  const leadId = useAppSelector((state) => state.common.leadId);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);
  const navigate = useNavigate();
  const initialAssignmentStatus = !!useAppSelector(
    (state) => state?.common?.partnerData?.showAssignmentFlag
  );
  const isAssignmentDataPresent = !!useAppSelector(
    (state) => state?.assignmentClauseDetails?.applicationId
  );
  const parentStepNo = useAppSelector((state) => state.stepDetails?.parentStepNo);

  const { mutate } = useMutation(loanDetailsUpdate);
  const { mutate: mutateDeleteAssignment, isError: isDeleteAssignmentError } =
    useMutation(deleteAssignmentDetails);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues: {
      applicationNumber: generalDetailsData.applicationNumber || "",
      serviceBranchCode: generalDetailsData.serviceBranchCode || "",
      serviceBranchName: generalDetailsData.serviceBranchName || "",
      bankDistributorName: generalDetailsData.bankDistributorName || "",
      ageasFederalEmployeeCode: generalDetailsData.ageasFederalEmployeeCode || "",
      bankCustomerId: generalDetailsData.bankCustomerId || "",
      branchSalesManagerCode: generalDetailsData.branchSalesManagerCode || "",
      typeOfLoan: generalDetailsData.typeOfLoan || "",
      st1Code: generalDetailsData.st1Code || "",
      isCoBorrower: generalDetailsData.isCoBorrower || false,
      isPrimaryBorrower: generalDetailsData.isPrimaryBorrower || false,
      isGuarantor: generalDetailsData.isGuarantor || false,
      isStaff: generalDetailsData.isStaff || false,
      staffEmpCode: generalDetailsData.staffEmpCode || "",
      staffCompany: generalDetailsData.staffCompany || "",
      staffCompanyCode: generalDetailsData.staffCompanyCode || "",
      staffST2Code: generalDetailsData.staffST2Code || "",
      masterPolicyNumber: generalDetailsData.masterPolicyNumber || "",
      masterPolicyHolderName: generalDetailsData.masterPolicyHolderName || "",
      assignmentFlag: generalDetailsData?.assignmentFlag
    },

    validationSchema: Yup.object().shape({
      applicationNumber: Yup.string().when([], (_, schema) =>
        genericDetails?.applicationNo?.required
          ? schema
              .required("Application Number is Required")
              .matches(regex.alphaNumeric, "Enter valid value")
              .min(5, "Enter 5 digit value")
              .max(20, "Enter 20 digit value")
          : schema.notRequired()
      ),
      serviceBranchCode: Yup.string().when([], (_, schema) =>
        genericDetails?.bankBranchCode?.required
          ? schema
              .required("Service Branch Code is Required")
              .matches(regex.alphaNumeric, "Enter valid value")
              .min(1, "Enter Min 1 digit value")
              .max(10, "Enter Max 10 digit value")
          : schema.notRequired()
      ),
      serviceBranchName: Yup.string().when([], (_, schema) =>
        genericDetails?.bankBranchName?.required
          ? schema
              .required("Service Branch Name is Required")
              .matches(regex.alphaNumericWithRestriction, "Enter valid value")
              .min(5, "Enter Min 5 digit value")
              .max(50, "Enter Max 50 digit value")
          : schema.notRequired()
      ),
      bankDistributorName: Yup.string().when([], (_, schema) =>
        genericDetails?.bankDistributorName.required
          ? schema.required("Required")
          : schema.notRequired()
      ),
      ageasFederalEmployeeCode: Yup.string().when([], (_, schema) =>
        genericDetails?.ageasFederalEmployeeCode.required
          ? schema.matches(regex.numeric, "Enter valid value").max(10, "Enter Max 10 digit value")
          : schema.notRequired()
      ),
      st1Code: Yup.string().when([], (_, schema) =>
        genericDetails.st1Code?.required
          ? schema
              .required("ST1 Code is Required")
              .min(3, "Enter Min 3 digit value")
              .max(15, "Enter Max 15 digit value")
          : schema
              .required("ST1 Code is Required")
              .matches(regex.alphaNumeric, "ST1Code special characters not allowed")
              .min(3, "Enter Min 3 digit value")
              .max(15, "Enter Max 15 digit value")
      ),
      branchSalesManagerCode: Yup.string().when([], (_, schema) =>
        genericDetails?.branchSalesManagerCode?.required
          ? schema
              .required("Branch Sales Manager Code is Required")
              .min(5, "Enter Min 5 digit value")
              .max(20, "Enter Max 20 digit value")
          : schema.notRequired()
      ),
      typeOfLoan: Yup.string().when([], (_, schema) =>
        genericDetails?.typeOfLoan?.required ? schema.required("Required") : schema.notRequired()
      ),
      bankCustomerId: Yup.string().when([], (_, schema) =>
        genericDetails?.bankCustomerId?.required
          ? schema.matches(regex.numeric, "Enter valid value").max(16, "Enter Max 16 digit value")
          : schema.notRequired()
      ),
      isStaff: Yup.boolean(),
      staffEmpCode: Yup.string().when("isStaff", ([isStaff], schema) =>
        isStaff
          ? schema
              .required("Employee Code is Required")
              .matches(regex.withoutSpaceAlphnumeric, "Invalid Employee Code")
              .min(3, "Enter Min 3 digit value")
              .max(10, "Enter max 10 digit value")
          : schema.notRequired()
      ),
      staffCompany: Yup.string().when("isStaff", ([isStaff], schema) =>
        isStaff && genericDetails?.staffCompany?.required
          ? schema.required("Company Name is Required")
          : schema.notRequired()
      ),
      staffST2Code: Yup.string(),
      masterPolicyNumber: Yup.string().when([], (_, schema) =>
        genericDetails?.masterPolicyNumber?.required
          ? schema
              .required("Master Policy Number is Required")
              .matches(regex.withoutSpaceAlphnumeric, "Invalid Master Policy Number")
              .max(8, "Enter Max 8 digit value")
          : schema.notRequired()
      ),
      masterPolicyHolderName: Yup.string().when([], (_, schema) =>
        genericDetails?.masterPolicyHolderName?.required
          ? schema
              .required("Master Policy Holder Name is Required")
              .matches(regex.alphaNumericWithSpace, "Invalid Master Policy Number")
              .max(50, "Enter Max 50 digit value")
          : schema.notRequired()
      ),
      assignmentFlag: Yup.boolean()
    }),

    onSubmit: (values) => {
      if (proposalStatus !== "MEF Submitted") {
        store.dispatch(setPostMEFLoading(true));
        mutate(
          {
            values,
            section: "general",
            leadId
          },
          {
            onSuccess: () => {
              dispatch(setGeneralDetails(values));
              if (values?.assignmentFlag) dispatch(setAssignmentFlagStatus(true));
              else {
                if (isAssignmentDataPresent)
                  mutateDeleteAssignment(leadId, {
                    onSuccess: () => {
                      store.dispatch(setAssignmentId());
                    },
                    onError: () => {
                      dispatch(
                        SET_TOAST_ERROR({
                          error: true,
                          duration: 4000,
                          message: "Please try again. Assignment details are not deleted"
                        })
                      );
                    }
                  });
                if (!isDeleteAssignmentError) dispatch(setAssignmentFlagStatus(false));
              }
              if (!isDeleteAssignmentError) {
                dispatch(setStepDetails({ parentStepNo: parentStepNo + 1, proposerStepNo: 1 }));
                window.scrollTo(0, 0);
              }
            },
            onSettled: () => {
              store.dispatch(setPostMEFLoading(false));
            }
          }
        );
      }
    }
  });

  const handleSubmit = () => {
    if (!formik.isValid) {
      setModalOpen(true);
      formik.handleSubmit();
    } else if (initialAssignmentStatus && !formik?.values?.assignmentFlag) {
      setAssignmentModalOpen(true);
    } else {
      formik.handleSubmit();
    }
  };

  return (
    <div>
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      {assignmentModalOpen && (
        <ConfirmationModal
          text={
            <div>
              <p>Assignment is selected as NO, Do you want to continue?</p>
            </div>
          }
          onNext={formik.handleSubmit}
          onCancel={() => setAssignmentModalOpen((prev) => !prev)}
        />
      )}
      <div className="min-h-screen bg-whiteSmoke pt-8 pb-19.5">
        <div className="w-full md:w-805/1000 mx-auto bg-white h-fit pt-8.5 pb-10 pr-10 pl-10.25 rounded-1.5xl">
          <DetailsHeading label="General" />
          <div className="mt-6">
            <BasicInfo formik={formik} genericDetails={genericDetails} />
          </div>
          <p className="font-montserrat text-black text-base font-bold mt-10 mb-6 flex">
            Bank Details
          </p>
          <BankDetails formik={formik} genericDetails={genericDetails} />
          <div className="mt-10 flex justify-center">
            <Button
              variant="outlined"
              classes={{ outlined: "!rounded-lg" }}
              onClick={() => navigate("/dashboard")}
              className="!text-black !uppercase h-13 w-37.5 rounded-lg !mr-10"
            >
              Back
            </Button>
            <Button
              variant="contained"
              classes={{ contained: "!rounded-lg" }}
              onClick={handleSubmit}
              className="!uppercase h-13 w-37.5 rounded-lg"
            >
              NEXT
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GeneralDetails;
